
const translation = [
    {name:"Interior Accent Grey", trans:"Gris Cristal - Negro"},
    {name:"Interior Accent Brown", trans:"Roast Francés - Negro"},
    {name:"Interior Accent Black", trans:"Bi-tono Negro con Quarzit"},
    {name:"Interior Accent Burgundy", trans:"Bi-tono Burgundy con Negro"},
    {name:"Interior Accent Cinnamon", trans:"Bi-tono Cinnamon con Negro"},
    {name:"Azul Cornflower", trans:"Azul Cornflower"},
    {name:"Gris Puro", trans:"Gris Puro"},
    {name:"Gris Platino", trans:"Gris Platino"},
    {name:"Negro Profundo", trans:"Negro Profundo"},
    {name:"Rojo Red", trans:"Rojo Rey"},
    {name:"Blanco Puro", trans:"Blanco Puro"},
    {name:"Katana", trans:"Rines de 18\" Katana"},
    {name:"Victoria Falls", trans:'Rines de 19" Victoria Falls'},
    {name:"Braselton", trans:'Rines de 21" Braselton'},
    {name:"seatFL", trans:"Asiento del conductor", de: "Fahrersitz"},
    {name:"seatFR", trans:"Asiento del copiloto", de: "Beifahrersitz"},
    {name:"seatRL", trans:"Asiento trasero izquierdo", de: "Rücksitz links"},
    {name:"seatRR", trans:"Asiento trasero derecho", de: "Rücksitz rechts"},
    {name:"Light Studio", trans:"Estudio", de: "Studio"},
    {name:"Evening Road", trans:"Carretera", de: "Landstraße"},
    {name:"Urban Night", trans:"Noche urbana", de: "Stadt"},
    {name:"Night Field", trans:"Cielo Estrellado", de: "Sternenhimmel"},
    {name:"Interior Accent Saffrano and Black", trans:"Bitono negro"},
    {name:"Interior Accent Storm Gray", trans:"Gris Storm"},
    {name:"Interior Accent Titan Black", trans:"Negro Titanio"},
    {name:"Interior Accent Dark Burgundy and Titan Black", trans:"Burgundy con Negro"},
    {name:"Interior Accent Titan Black and Quarz", trans:"Negro con Quarzit"},
    {name:"Interior Accent Crystal Grey - Black", trans:"Gris Cristal - Negro"},
    {name:"Interior Accent Negro Gris", trans: "Negro Gris"},
    {name:"Paint Mondsteingrau", trans: "Moonstone Gray", de:"Mondsteingrau"},
    {name:"Paint Mondsteingrau Black", trans:"Mondsteingrau Black"},
    {name:"Paint Mondsteingrau Silver", trans: "Moonstone Gray Silver", de:"Mondsteingrau Silver"},
    {name:"Paint Mondsteingrau Silver ID3", trans:"Mondsteingrau Silver"},
    {name:"Paint Mondsteingrau Penny Copper", trans:"Mondsteingrau Penny Copper"},

    {name:"Paint Blue Dusk", trans: "Dusk Blue Metallic", de:"Blue Dusk"},
    {name:"Paint Blue Dusk Silver", trans: "Dusk Blue Metallic Silver", de:"Blue Dusk Silver"},

    {name:"Paint Gletscherweiß", trans: "Glacier White Metallic", de:"Gletscherweiß"},
    {name:"Paint Gletscherweiß Black", trans:"Gletscherweiß Black"},
    {name:"Paint Gletscherweiß Silver", trans:"Glacier White Metallic Silver", de:"Gletscherweiß Silver"},
    {name:"Paint Gletscherweiß Silver ID3", trans:"Glacier White Metallic Silver", de:"Gletscherweiß Silver"},
    {name:"Paint Gletscherweiß Penny Copper", trans:"Gletscherweiß Penny Copper"},

    {name:"Paint Makena-Türkis", trans:"Makena-Türkis"},
    {name:"Paint Makena-Türkis Black", trans: "Makena-Türkis Black"},
    {name:"Paint Makena-Türkis Silver", trans:"Makena-Türkis Silver"},
    {name:"Paint Kings Red", trans:"Kings Red Metallic", de:"Kings Red"},
    {name:"Paint Kings Red Black", trans:"Kings Red Black"},
    {name:"Paint Kings Red Silver", trans:"Kings Red Metallic Silver", de:"Kings Red Silver"},
    {name:"Paint Kings Red Silver ID3", trans:"Kings Red Silver"},
    {name:"Paint Mangangrau", trans:"Manganese Gray Metallic", de:"Mangangrau"},
    {name:"Paint Mangangrau Black", trans:"Mangangrau Black"},
    {name:"Paint Mangangrau Silver", trans:"Manganese Gray Metallic Silver", de:"Mangangrau Silver"},
    {name:"Paint Mangangrau Silver ID3", trans:"Mangangrau Silver"},
    {name:"Paint Mangangrau Penny Copper", trans:"Mangangrau Penny Copper"},
    {name:"Paint Stonewashed Blue", trans:"Stonewashed Blue Metallic", de:"Stonewashed Blue"},
    {name:"Paint Stonewashed Blue Black", trans:"Stonewashed Blue Black"},
    {name:"Paint Stonewashed Blue Silver", trans:"Stonewashed Blue Metallic Silver", de:"Stonewashed Blue Silver"},
    {name:"Paint Stonewashed Blue Silver ID3", trans:"Stonewashed Blue Silver"},
    {name:"Paint Stonewashed Blue Penny Copper", trans:"Stonewashed Blue Penny Copper"},
    {name:"Paint Scale Silver", trans:"Scale Silver Metallic", de:"Scale Silver"},
    {name:"Paint Scale Silver Black", trans:"Scale Silver Black"},
    {name:"Paint Scale Silver Penny Copper", trans:"Scale Silver Penny Copper"},
    {name:"Paint Mythosschwarz", trans:"Mythosschwarz"},
    {name:"Paint Mondsteingrau Schwarz", trans: "Mondsteingrau"},
    {name:"Paint Gletscherweiß Schwarz", trans: "Gletscherweiß"},
    {name:"Paint Kings Red Schwarz", trans: "Kings Red"},
    {name:"Paint Mangangrau Schwarz", trans: "Mangangrau"},
    {name:"Paint Stonewashed Blue Schwarz", trans: "Stonewashed Blue"},
    {name:"Paint Scale Silver Schwarz", trans: "Scale Silver"},
    {name:"id_disclaimer_main_1", trans:"La publicación o reproducción de la aplicación y todos sus componentes, en su totalidad o en partes, para uso privado o comercial está prohibido. Al hacer clic en el botón de abajo, usted acepta estas condiciones.", de:"Die Veröffentlichung oder Duplizierung der Anwendung und aller darin enthaltenen Bestandteile ist, in Teilen oder als Ganzes, für private oder kommerzielle Nutzung untersagt. Mit einem Klick auf den unten befindlichen Button akzeptieren Sie diese Bedingung."},
    {name:"id_disclaimer_main_2", trans:"Las animaciones no muestran ninguna función técnicamente correcta.", de:"Die Animationen zeigen keine technisch korrekten Funktionen."},
    {name:"id_select", trans: "Seleccionar", de: "Auswählen"},
    {name:"id_selected", trans: "Seleccionado", de: "Ausgewählt"},
    {name:"id_bags_20l", trans: "bolsas de 20L", de: "20L-Taschen"},
    {name:"id_bottles_1.5l", trans: "botellas de 1.5L", de: "1,5L-Flaschen"},
    {name:"id_interested", trans: "Me Interesa", de: "Jetzt anfragen"},
    {name:"id_experience", trans: "Experiméntalo", de: "Entdecken"},
    {name:"id_personalize", trans: "Personalízalo", de: "Personalisieren"},
    {name:"id_my_next", trans: "Mi próximo", de: "Mein nächster"},
    {name:"id_config_not_available", trans: "*Model is not available in this configuration.", de: "*Fahrzeug zeigt Sonderfarbe, die nicht erhältlich ist."},
    {name:"id_ar", trans: "RA", de: "AR"},
    {name:"Model Change", trans: "Cambiar modelo", de: "Fahrzeugwechsel"},
    {name:"Click to start", trans: "Da clic para comenzar", de: "Klicke um zu starten"},
    {name:"and explore your VW", trans: "a explorar tu VW", de: "und erforsche deinen VW"},
    {name:"Starting Experience...", trans: "Cargando tu VW...", de: "Dein VW wird geladen..."},
    {name:"Preparing AR Experience...", trans: "Cargando tu VW en RA...", de: "Dein VW wird in AR geladen..."},
    {name:"Sound on", trans: "Sonido", de: "Sound"},
    {name:"Sound off", trans: "Sonido", de: "Sound"},
    {name:"id_xr_scale_1_to_1", trans: "1:1", de: "1:1 Skalierung" /* english: 1:1 Scale */},
    {name:"id_xr_scale_table", trans:"Mesa", de: "Tisch", /* english: Table */},
    {name:"id_xr_scan", trans:"Mueve el Android para empezar", de: "Bewege dein Android" /* english: Move your phone around */},
    {name:"id_xr_place", trans:"Da clic en el logo para ver tu VW", de: "Klicke auf das Logo um deinen VW zu platzieren"/* english: Tap on the logo to place your new Volkswagen */},

    {name:"Interior Accent Cinnamon and Titan Black", trans:"Cinnamon con Negro"},
    {name:"Interior Accent Noisette and Black", trans:"Negro - Noisette"},
    {name:"Interior Black", trans:"Negro"},
    {name:"Interior Accent Burgundy and Black", trans:"BG – Negro (Leather)"},
    {name:"Valencia 19\"", trans:"Valencia Black 19\""},

    {name:"Soul Schwarz - Florence Braun - Akzent Weiß", trans:"Soul Black - Florence Brown - Accent White", de:"Soul Schwarz - Florence Braun - Akzent Weiß"},
    {name:"Soul Schwarz - Florence Braun - Akzent Schwarz", trans:"Soul Black - Florence Brown - Accent Black", de:"Soul Schwarz - Florence Braun - Akzent Schwarz"},
    {name:"Soul Schwarz - Platinum Grey - Akzent Schwarz", trans:"Soul Black - Platinum Grey - Accent Black", de:"Soul Schwarz - Platinum Grey - Akzent Schwarz"},
    {name:"Soul Schwarz - Florence Braun - Sport", trans:"Soul Black - Florence Brown - Sport", de:"Soul Schwarz - Florence Braun - Sport"},
    {name:"Soul Schwarz - Florence Braun - Akzent Weiß", trans:"Soul Black - Sport", de:"Soul Schwarz - Sport"},

    {
        name: "disclaimer_id4_pure",
        trans: "La versión del vehículo mostrado es un ID.4 Pure año modelo 2022, el cual no se comercializa en Mexico.<br><br>La configuración, versión y equipamiento aquí mostrado es de un vehículo comercializado en territorio alemán, por lo tanto dicha configuración y disponibilidad no aplica para el mercado mexicano.",
        de: "Das abgebildete Fahrzeug zeigt einen ID. 4 Pure aus dem Modelljahr 2022. Für genauere Beschreibungen wenden Sie sich an Ihren Volkswagen Partner."
    },
    {
        name: "disclaimer_id4_pro",
        trans: "La versión del vehículo mostrado es un ID.4 Pro año modelo 2022, el cual no se comercializa en Mexico.<br><br>La configuración, versión y equipamiento aquí mostrado es de un vehículo comercializado en territorio alemán, por lo tanto dicha configuración y disponibilidad no aplica para el mercado mexicano.",
        de: "Das abgebildete Fahrzeug zeigt einen ID. 4 Pro aus dem Modelljahr 2022. Für genauere Beschreibungen wenden Sie sich an Ihren Volkswagen Partner."
    },
    {
        name: "disclaimer_id4_gtx",
        trans: "La versión del vehículo mostrado es un ID.4 GTX año modelo 2022, el cual no se comercializa en Mexico.<br><br>La configuración, versión y equipamiento aquí mostrado es de un vehículo comercializado en territorio alemán, por lo tanto dicha configuración y disponibilidad no aplica para el mercado mexicano.",
        de: "Das abgebildete Fahrzeug zeigt einen ID. 4 GTX aus dem Modelljahr 2022. Für genauere Beschreibungen wenden Sie sich an Ihren Volkswagen Partner."
    },

    {
        name: "Interior Accent Negro Gris Titanio",
        trans: "Negro - Gris Titanio"
    }
]

const tracking = [
    {name:"seatFL", trans:"choose seat front left"},
    {name:"seatFR", trans:"choose seat front right"},
    {name:"seatRL", trans:"choose seat back left"},
    {name:"seatRR", trans:"choose seat back right"}
]

export function translate(name:string):string {
    const trans = translation.find(e => e.name === name);
    
    if (!trans) return name;
    
    // HACK: IF THERE IS DE STUFF WE USE IT!!!
    if (trans.de) return trans.de;

    return trans.trans;
}

export function translateTrack(name:string):string {
    let trans = tracking.find(e => e.name === name);
    if(trans){
        return trans.trans;
    }
    return name;
}